export const Routes = {
  home: "/",
  login: "/login",
  idm:'/idm'
};
